// src/screens/LogoutScreen.jsx
import React from "react";
import { CircularProgress, Typography, Box, Button } from "@mui/material";
import API from "../API"; // your file above exports `s` as default

export default class LogoutScreen extends React.Component {
  state = { done: false, error: null };

  async componentDidMount() {
    try {
      if (API.user?.jyskRole === "finance") {
        const response = await fetch(`${API.SERVER_ADDRESS}jysk/logout`, { method: "POST", headers: { "Content-Type": "application/json", Authorization: `Bearer ${API.token || localStorage.getItem("bearerToken")}` }, body: "{}" });
        if (!response.ok && response.status !== 401) throw new Error("Çıkış tamamlanamadı. Yeniden deneyin.");
      }

      // Clear local auth/cache
      if (window?.localStorage) {
        localStorage.removeItem("bearerToken");
        localStorage.removeItem("cache");
      }
      // Clear globals used in your app
      if (global?.cache) delete global.cache;
      API.user = undefined;
      API.token = undefined;

      // Small delay so user sees the spinner
      setTimeout(() => {
        // Prefer history (RR v5). Fallback to hard redirect.
        if (this.props?.history?.replace) {
          this.props.history.replace("/login");
        } else {
          window.location.href = "/login";
        }
      }, 400);
    } catch (err) {
      this.setState({ error: err?.message || "Çıkış yapılamadı" });
    }
  }

  render() {
    return (
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "#F9FAFC",
          p: 3,
          textAlign: "center",
        }}
      >
        <Box>
          <CircularProgress />
          <Typography variant="h6" sx={{ mt: 2 }}>
            Çıkış yapılıyor…
          </Typography>
          {this.state.error && (
            <>
              <Typography color="error" sx={{ mt: 1 }}>
                {this.state.error}
              </Typography>
              <Button
                sx={{ mt: 2 }}
                variant="contained"
                onClick={() => window.location.reload()}
              >
                Tekrar Dene
              </Button>
            </>
          )}
        </Box>
      </Box>
    );
  }
}
